export default {"src":"/_next/static/media/rightArrow.8790aed2.svg","height":14,"width":13};